// extracted by mini-css-extract-plugin
module.exports = {"images":"Gallery-module__images___3KFLX","image":"Gallery-module__image___3Pe-Y","nav":"Gallery-module__nav___m2rBa","next":"Gallery-module__next___67XhU"};